import {IconWrapperIconProps} from "app/Interface/Component/Icons"
import IconWrapper from "app/WebView/Component/icons/icon"
import React from "react"
import BackIconSvg from "static/icons/arrow_back_black_24dp.svg"

const BackIcon = (props: IconWrapperIconProps) => {
  const name = "back"
  return (
    <IconWrapper name={name} {...props}>
      <BackIconSvg/>
    </IconWrapper>
  )
}

export default BackIcon
